import { render, staticRenderFns } from "./InputGroupRating.vue?vue&type=template&id=d50415b6"
import script from "./InputGroupRating.vue?vue&type=script&lang=js"
export * from "./InputGroupRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports